import { reducer as appReducer } from 'js/components/system/App/store/reducer';
import { reducer as userReducer } from 'js/hooks/user/store/reducer';
import { reducer as i18nReducer } from 'js/hooks/i18n/store/reducer';
import { reducer as authReducer } from 'js/hooks/auth/store/reducer';
import { reducer as deviceReducer } from 'js/hooks/device/store/reducer';
import { reducer as sessionReducer } from 'js/hooks/session/store/reducer';
import { reducer as formsReducer } from 'js/hooks/useGetForms/store/reducer';
import { reducer as pageReducer } from 'js/components/system/Page/store/reducer';
import { reducer as footerReducer } from 'js/components/main/Footer/store/reducer';
import { reducer as jackpotsReducer } from 'js/components/common/Jackpot/store/reducer';
import { reducer as popupsReducer } from 'js/components/common/PopupManager/store/reducer';
import { reducer as socketReducer } from 'js/hooks/socket/hooks/useOAPISocket/store/reducer';
import { reducer as liveGamesReducer } from 'js/hooks/useLiveGamesIntegration/store/reducer';
import { reducer as maintenanceReducer } from 'js/components/system/Maintenance/store/reducer';
import { reducer as cookieSettingsReducer } from 'js/components/main/CookieSettings/store/reducer';
import { reducer as myAccountSidebarReducer } from 'js/components/main/MyAccountSidebar/store/reducer';
import { reducer as communicationWidgetsReducer } from 'js/components/system/CommunicationWidgets/store/reducer';
import { reducer as sportsbookReducer } from 'js/components/system/App/components/AppPostInit/hooks/useSportsbookIntegration/store/reducer';

import * as Types from './types';
import * as constants from './constants';

export const staticReducers = {
    [constants.APP_REDUCER]: appReducer,
    [constants.USER_REDUCER]: userReducer,
    [constants.SOCKET_REDUCER]: socketReducer,
    [constants.PAGE_REDUCER]: pageReducer,
    [constants.AUTH_REDUCER]: authReducer,
    [constants.I18N_REDUCER]: i18nReducer,
    [constants.FORMS_REDUCER]: formsReducer,
    [constants.DEVICE_REDUCER]: deviceReducer,
    [constants.FOOTER_REDUCER]: footerReducer,
    [constants.SESSION_REDUCER]: sessionReducer,
    [constants.JACKPOTS_REDUCER]: jackpotsReducer,
    [constants.LIVE_GAMES_REDUCER]: liveGamesReducer,
    [constants.SPORTSBOOK_REDUCER]: sportsbookReducer,
    [constants.MAINTENANCE_MODE_REDUCER]: maintenanceReducer,
    [constants.COOKIE_SETTINGS_REDUCER]: cookieSettingsReducer,
    [constants.MY_ACCOUNT_SIDEBAR_REDUCER]: myAccountSidebarReducer,
    [constants.COMMUNICATION_WIDGETS_REDUCER]: communicationWidgetsReducer,
    [constants.POPUPS_REDUCER]: popupsReducer as Types.TCommonReducer
};
